import { render, staticRenderFns } from "./config_pentest.vue?vue&type=template&id=2ad3f54a&scoped=true"
import script from "./config_pentest.vue?vue&type=script&lang=js"
export * from "./config_pentest.vue?vue&type=script&lang=js"
import style0 from "./config_pentest.vue?vue&type=style&index=0&id=2ad3f54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3f54a",
  null
  
)

export default component.exports